import { getProperty } from "@/util/object"
import { sortBy } from "@/util/array"

const defaultProp = "___default___"

export default  {

    props: {
        options: {
            type: Array,
            required: true,
        },
        nameField: {
            type: [Function, String],
            default: "name",
        },
        valueField: {
            type: [Function, String],
            default: "value",
        },
        filterBy: {
            type: [Function, String],
        },
        sortBy: {
            type: [Function, String],
        },
    },

    created() {
        this.$defaultProp = defaultProp
    },

    computed: {
        computedOptions() {
            let options = [...this.options]
            if (this.predicate) {
                options = options.filter(this.predicate)
            }

            if (this.sortBy) {
                options = sortBy(options, this.sortBy)
            }

            return this.customizeOptions(options)
        },

        predicate() {
            if (typeof this.filterBy === "string") {
                return item => !!getProperty(item, this.filterBy)
            }

            if (typeof this.filterBy === "function") {
                return this.filterBy
            }

            return null
        },

        nameGetter() {
            const getter = toGetter(this.nameField)

            return item => {
                if (!item) return null

                if (item[this.$defaultProp]) {
                    return item.name
                }

                return getter(item)
            }
        },

        valueGetter() {
            const getter = toGetter(this.valueField)

            return item => {
                if (!item) return null

                if (item[defaultProp]) {
                    return item.value
                }

                return getter(item)
            }
        },
    },

    methods: {
        getName(item) {
            return this.nameGetter(item)
        },

        getValue(item) {
            return this.valueGetter(item)
        },

        customizeOptions(options) {
            return options;
        }
    }
}

function toGetter(prop) {
    if (typeof prop === "string") {
        return item => getProperty(item, prop)
    }

    if (typeof prop === "function") {
        return prop
    }

    return item => item
}
